const { trackGtm4 } = require('util/functions');

module.exports = {
	init() {
		const link = this.root.querySelector('.box-article-content--link');
		const title = this.root.querySelector('.topic-highlight--content h2');
		const widgetName = this.root.getAttribute('data-parent');
		const widgetTitle = this.root.getAttribute('data-parent-title');

		if (link) {
			link.addEventListener('click', () => {
				trackGtm4({
					event: 'GA4_event_c_cta',
					widget_name: widgetName,
					widget_title: widgetTitle
						? widgetTitle
						: title
						? title.innerHTML
						: 'No title: Title not set',
					link_text: link.innerHTML ? link.innerHTML : 'No text: Text not set',
					link_url: link.href,
					button_type: '',
				});
			});
		}
	},
};
